import type {
  HeadersList,
  Transaction as NetworkTransaction,
} from '@carboncopyco/types';
import type { JsonFieldSchema } from '../JsonForm';
import type { DynamicResponseModifier } from '../TransactionRuleForm';

export enum CreateTransactionRuleStep {
  SelectTransaction = 'SelectTransaction',
  CreateTransactionSelectors = 'CreateTransactionSelectors',
  CreateTransactionModifiers = 'CreateTransactionModifiers',
  CreateResponseVisualization = 'CreateResponseVisualization',
  GeneralSettings = 'GeneralSettings',
}

export type TransactionModifiersForm = {
  name: string;
  description: string;
  selectors: string;
  response: string;
  dynamicResponseModifiers: DynamicResponseModifier[];
  responseType: 'static' | 'dynamic' | 'custom';
  headers?: HeadersList;
  representationType?: 'raw' | 'form';
  representationFields?: JsonFieldSchema[];
  customModifier?: string;
};

export interface Transaction extends NetworkTransaction {
  id: string;
}
